// GENERATED FILE — do not hand-edit. Rebuild with:
//   node scripts/build-variant-maps.mjs
// Per-card booster-pull print variants, sourced from tcgdex variants_detailed.
// Consumed by src/utils/cardVariants.js (map layer of the derivation ladder).
export default {
 "_meta": {
  "generated": "2026-07-27",
  "source": "tcgdex variants_detailed",
  "sets": {
   "sv8pt5": {
    "tcgdexId": "sv08.5",
    "name": "Prismatic Evolutions",
    "cards": 175,
    "regularClamped": 1,
    "holoBackfilled": 0,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 5,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:cosmos": 8,
     "size:jumbo": 4,
     "reverse:cosmos": 1,
     "holo:gold": 5
    }
   },
   "zsv10pt5": {
    "tcgdexId": "sv10.5b",
    "name": "Black Bolt",
    "cards": 172,
    "regularClamped": 2,
    "holoBackfilled": 2,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:tinsel": 1,
     "holo:cosmos": 1
    }
   },
   "rsv10pt5": {
    "tcgdexId": "sv10.5w",
    "name": "White Flare",
    "cards": 173,
    "regularClamped": 1,
    "holoBackfilled": 1,
    "rareReverseRepaired": 6,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:tinsel": 2
    }
   },
   "me1": {
    "tcgdexId": "me01",
    "name": "Mega Evolution",
    "cards": 188,
    "regularClamped": 5,
    "holoBackfilled": 0,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:cosmos": 18
    }
   },
   "me2": {
    "tcgdexId": "me02",
    "name": "Phantasmal Flames",
    "cards": 129,
    "regularClamped": 5,
    "holoBackfilled": 1,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 1,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:cosmos": 1,
     "holo:gold": 1
    }
   },
   "me2pt5": {
    "tcgdexId": "me02.5",
    "name": "Ascended Heroes",
    "cards": 295,
    "regularClamped": 0,
    "holoBackfilled": 0,
    "rareReverseRepaired": 25,
    "plainReverseRepaired": 115,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {}
   },
   "me3": {
    "tcgdexId": "me03",
    "name": "Perfect Order",
    "cards": 124,
    "regularClamped": 10,
    "holoBackfilled": 1,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:cosmos": 3
    }
   },
   "me4": {
    "tcgdexId": "me04",
    "name": "Chaos Rising",
    "cards": 121,
    "regularClamped": 4,
    "holoBackfilled": 3,
    "rareReverseRepaired": 12,
    "plainReverseRepaired": 64,
    "unmatchedCards": 1,
    "thinCommons": 0,
    "skippedFoils": {
     "holo:gold": 1
    }
   },
   "me5": {
    "tcgdexId": "me05",
    "name": "Pitch Black",
    "cards": 120,
    "regularClamped": 4,
    "holoBackfilled": 4,
    "rareReverseRepaired": 7,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {}
   },
   "mep": {
    "tcgdexId": "mep",
    "name": "MEP Black Star Promos",
    "cards": 60,
    "regularClamped": 0,
    "holoBackfilled": 0,
    "rareReverseRepaired": 0,
    "plainReverseRepaired": 0,
    "unmatchedCards": 0,
    "thinCommons": 0,
    "skippedFoils": {
     "size:jumbo": 9
    }
   }
  }
 },
 "sets": {
  "sv8pt5": {
   "1": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "2": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "3": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "4": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "5": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "6": [
    "Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "8": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "9": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "10": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "11": [
    "Holo"
   ],
   "12": [
    "Holo"
   ],
   "13": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "14": [
    "Holo"
   ],
   "15": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "16": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "17": [
    "Holo"
   ],
   "18": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "19": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "20": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "21": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "22": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "23": [
    "Holo"
   ],
   "24": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "25": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "26": [
    "Holo"
   ],
   "27": [
    "Holo"
   ],
   "28": [
    "Holo"
   ],
   "29": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "30": [
    "Holo"
   ],
   "31": [
    "Holo"
   ],
   "32": [
    "Holo"
   ],
   "33": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "34": [
    "Holo"
   ],
   "35": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "36": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "37": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "38": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "39": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "40": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "41": [
    "Holo"
   ],
   "42": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "43": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "44": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "45": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "46": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "47": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "48": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "49": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "50": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "51": [
    "Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "53": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "54": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "55": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "56": [
    "Holo"
   ],
   "57": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "58": [
    "Holo"
   ],
   "59": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "60": [
    "Holo"
   ],
   "61": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "62": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "63": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "64": [
    "Holo"
   ],
   "65": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "66": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "67": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "68": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "69": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "70": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "71": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "72": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "73": [
    "Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "75": [
    "Holo"
   ],
   "76": [
    "Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "78": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "79": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "80": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "81": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "82": [
    "Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "84": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "85": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "86": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "87": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "88": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "89": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "90": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "94": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "95": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "96": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "97": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "98": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "99": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "100": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "101": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "102": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "103": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "104": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "105": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "106": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "107": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "108": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "109": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "110": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "111": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "112": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "113": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "114": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "115": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "121": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "122": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "123": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "124": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "125": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "126": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "127": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "128": [
    "Holo"
   ],
   "129": [
    "Holo"
   ],
   "130": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "131": [
    "Holo"
   ],
   "132": [
    "Holo"
   ],
   "133": [
    "Holo"
   ],
   "134": [
    "Holo"
   ],
   "135": [
    "Holo"
   ],
   "136": [
    "Holo"
   ],
   "137": [
    "Holo"
   ],
   "138": [
    "Holo"
   ],
   "139": [
    "Holo"
   ],
   "140": [
    "Holo"
   ],
   "141": [
    "Holo"
   ],
   "142": [
    "Holo"
   ],
   "143": [
    "Holo"
   ],
   "144": [
    "Holo"
   ],
   "145": [
    "Holo"
   ],
   "146": [
    "Holo"
   ],
   "147": [
    "Holo"
   ],
   "148": [
    "Holo"
   ],
   "149": [
    "Holo"
   ],
   "150": [
    "Holo"
   ],
   "151": [
    "Holo"
   ],
   "152": [
    "Holo"
   ],
   "153": [
    "Holo"
   ],
   "154": [
    "Holo"
   ],
   "155": [
    "Holo"
   ],
   "156": [
    "Holo"
   ],
   "157": [
    "Holo"
   ],
   "158": [
    "Holo"
   ],
   "159": [
    "Holo"
   ],
   "160": [
    "Holo"
   ],
   "161": [
    "Holo"
   ],
   "162": [
    "Holo"
   ],
   "163": [
    "Holo"
   ],
   "164": [
    "Holo"
   ],
   "165": [
    "Holo"
   ],
   "166": [
    "Holo"
   ],
   "167": [
    "Holo"
   ],
   "168": [
    "Holo"
   ],
   "169": [
    "Holo"
   ],
   "170": [
    "Holo"
   ],
   "171": [
    "Holo"
   ],
   "172": [
    "Holo"
   ],
   "173": [
    "Holo"
   ],
   "174": [
    "Holo"
   ],
   "175": [
    "Holo"
   ]
  },
  "zsv10pt5": {
   "1": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "2": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "3": [
    "Holo"
   ],
   "4": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "5": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "6": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "7": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "8": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "9": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "10": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "11": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "12": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "13": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "14": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "15": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "16": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "17": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "18": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "19": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "20": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "21": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "22": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "23": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "24": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "25": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "26": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "27": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "28": [
    "Holo"
   ],
   "29": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "30": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "31": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "32": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "33": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "34": [
    "Holo"
   ],
   "35": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "36": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "37": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "38": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "39": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "40": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "41": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "42": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "43": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "44": [
    "Holo"
   ],
   "45": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "46": [
    "Holo"
   ],
   "47": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "48": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "49": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "50": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "51": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "52": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "53": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "54": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "55": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "56": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "57": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "58": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "59": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "60": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "61": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "62": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "63": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "64": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "65": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "66": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "67": [
    "Holo"
   ],
   "68": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "69": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "70": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "71": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "72": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "73": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "74": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "75": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "76": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "77": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "78": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "79": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "80": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "81": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "82": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "83": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "84": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "85": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "86": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "87": [
    "Holo"
   ],
   "88": [
    "Holo"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Holo"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ],
   "121": [
    "Holo"
   ],
   "122": [
    "Holo"
   ],
   "123": [
    "Holo"
   ],
   "124": [
    "Holo"
   ],
   "125": [
    "Holo"
   ],
   "126": [
    "Holo"
   ],
   "127": [
    "Holo"
   ],
   "128": [
    "Holo"
   ],
   "129": [
    "Holo"
   ],
   "130": [
    "Holo"
   ],
   "131": [
    "Holo"
   ],
   "132": [
    "Holo"
   ],
   "133": [
    "Holo"
   ],
   "134": [
    "Holo"
   ],
   "135": [
    "Holo"
   ],
   "136": [
    "Holo"
   ],
   "137": [
    "Holo"
   ],
   "138": [
    "Holo"
   ],
   "139": [
    "Holo"
   ],
   "140": [
    "Holo"
   ],
   "141": [
    "Holo"
   ],
   "142": [
    "Holo"
   ],
   "143": [
    "Holo"
   ],
   "144": [
    "Holo"
   ],
   "145": [
    "Holo"
   ],
   "146": [
    "Holo"
   ],
   "147": [
    "Holo"
   ],
   "148": [
    "Holo"
   ],
   "149": [
    "Holo"
   ],
   "150": [
    "Holo"
   ],
   "151": [
    "Holo"
   ],
   "152": [
    "Holo"
   ],
   "153": [
    "Holo"
   ],
   "154": [
    "Holo"
   ],
   "155": [
    "Holo"
   ],
   "156": [
    "Holo"
   ],
   "157": [
    "Holo"
   ],
   "158": [
    "Holo"
   ],
   "159": [
    "Holo"
   ],
   "160": [
    "Holo"
   ],
   "161": [
    "Holo"
   ],
   "162": [
    "Holo"
   ],
   "163": [
    "Holo"
   ],
   "164": [
    "Holo"
   ],
   "165": [
    "Holo"
   ],
   "166": [
    "Holo"
   ],
   "167": [
    "Holo"
   ],
   "168": [
    "Holo"
   ],
   "169": [
    "Holo"
   ],
   "170": [
    "Holo"
   ],
   "171": [
    "Holo"
   ],
   "172": [
    "Holo"
   ]
  },
  "rsv10pt5": {
   "1": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "2": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "3": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "4": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "5": [
    "Holo"
   ],
   "6": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "7": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "8": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "9": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "10": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "11": [
    "Regular",
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "12": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "13": [
    "Reverse Holo",
    "Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "14": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "15": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "16": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "17": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "18": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "19": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "20": [
    "Holo"
   ],
   "21": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "22": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "23": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "24": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "25": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "26": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "27": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "28": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "29": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "30": [
    "Holo"
   ],
   "31": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "32": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "33": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "34": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "35": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "36": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "37": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "38": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "39": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "40": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "41": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "42": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "43": [
    "Holo",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "44": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "45": [
    "Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "47": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "48": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "49": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "50": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "51": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "53": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "54": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "55": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "56": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "57": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "58": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "59": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "60": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "61": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "62": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "64": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "65": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "66": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "67": [
    "Holo"
   ],
   "68": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "69": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "70": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "71": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "72": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "73": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "74": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "75": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "76": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Master Ball"
   ],
   "77": [
    "Holo"
   ],
   "78": [
    "Holo",
    "Poke Ball",
    "Master Ball",
    "Reverse Holo"
   ],
   "79": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "80": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "81": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "82": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "83": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "84": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "85": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "86": [
    "Regular",
    "Reverse Holo",
    "Poke Ball"
   ],
   "87": [
    "Holo"
   ],
   "88": [
    "Holo"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Holo"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ],
   "121": [
    "Holo"
   ],
   "122": [
    "Holo"
   ],
   "123": [
    "Holo"
   ],
   "124": [
    "Holo"
   ],
   "125": [
    "Holo"
   ],
   "126": [
    "Holo"
   ],
   "127": [
    "Holo"
   ],
   "128": [
    "Holo"
   ],
   "129": [
    "Holo"
   ],
   "130": [
    "Holo"
   ],
   "131": [
    "Holo"
   ],
   "132": [
    "Holo"
   ],
   "133": [
    "Holo"
   ],
   "134": [
    "Holo"
   ],
   "135": [
    "Holo"
   ],
   "136": [
    "Holo"
   ],
   "137": [
    "Holo"
   ],
   "138": [
    "Holo"
   ],
   "139": [
    "Holo"
   ],
   "140": [
    "Holo"
   ],
   "141": [
    "Holo"
   ],
   "142": [
    "Holo"
   ],
   "143": [
    "Holo"
   ],
   "144": [
    "Holo"
   ],
   "145": [
    "Holo"
   ],
   "146": [
    "Holo"
   ],
   "147": [
    "Holo"
   ],
   "148": [
    "Holo"
   ],
   "149": [
    "Holo"
   ],
   "150": [
    "Holo"
   ],
   "151": [
    "Holo"
   ],
   "152": [
    "Holo"
   ],
   "153": [
    "Holo"
   ],
   "154": [
    "Holo"
   ],
   "155": [
    "Holo"
   ],
   "156": [
    "Holo"
   ],
   "157": [
    "Holo"
   ],
   "158": [
    "Holo"
   ],
   "159": [
    "Holo"
   ],
   "160": [
    "Holo"
   ],
   "161": [
    "Holo"
   ],
   "162": [
    "Holo"
   ],
   "163": [
    "Holo"
   ],
   "164": [
    "Holo"
   ],
   "165": [
    "Holo"
   ],
   "166": [
    "Holo"
   ],
   "167": [
    "Holo"
   ],
   "168": [
    "Holo"
   ],
   "169": [
    "Holo"
   ],
   "170": [
    "Holo"
   ],
   "171": [
    "Holo"
   ],
   "172": [
    "Holo"
   ],
   "173": [
    "Holo"
   ]
  },
  "me1": {
   "1": [
    "Regular",
    "Reverse Holo",
    "League Pattern"
   ],
   "2": [
    "Regular",
    "Reverse Holo"
   ],
   "3": [
    "Holo"
   ],
   "4": [
    "Regular",
    "Reverse Holo"
   ],
   "5": [
    "Regular",
    "Reverse Holo"
   ],
   "6": [
    "Regular",
    "Reverse Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo"
   ],
   "8": [
    "Regular",
    "Reverse Holo"
   ],
   "9": [
    "Regular",
    "Reverse Holo"
   ],
   "10": [
    "Holo",
    "Reverse Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo"
   ],
   "12": [
    "Regular",
    "Reverse Holo"
   ],
   "13": [
    "Regular",
    "Reverse Holo"
   ],
   "14": [
    "Regular",
    "Reverse Holo"
   ],
   "15": [
    "Regular",
    "Reverse Holo"
   ],
   "16": [
    "Regular",
    "Reverse Holo"
   ],
   "17": [
    "Regular",
    "Reverse Holo"
   ],
   "18": [
    "Regular",
    "Reverse Holo"
   ],
   "19": [
    "Regular",
    "Reverse Holo"
   ],
   "20": [
    "Regular",
    "Reverse Holo"
   ],
   "21": [
    "Regular",
    "Reverse Holo"
   ],
   "22": [
    "Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo"
   ],
   "24": [
    "Regular",
    "Reverse Holo"
   ],
   "25": [
    "Regular",
    "Reverse Holo"
   ],
   "26": [
    "Regular",
    "Reverse Holo"
   ],
   "27": [
    "Regular",
    "Reverse Holo"
   ],
   "28": [
    "Holo",
    "Reverse Holo"
   ],
   "29": [
    "Regular",
    "Reverse Holo"
   ],
   "30": [
    "Regular",
    "Reverse Holo"
   ],
   "31": [
    "Regular",
    "Reverse Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo"
   ],
   "33": [
    "Regular",
    "Reverse Holo"
   ],
   "34": [
    "Holo",
    "Reverse Holo"
   ],
   "35": [
    "Regular",
    "Reverse Holo"
   ],
   "36": [
    "Holo"
   ],
   "37": [
    "Regular",
    "Reverse Holo"
   ],
   "38": [
    "Holo",
    "Reverse Holo"
   ],
   "39": [
    "Regular",
    "Reverse Holo"
   ],
   "40": [
    "Regular",
    "Reverse Holo"
   ],
   "41": [
    "Regular",
    "Reverse Holo"
   ],
   "42": [
    "Regular",
    "Reverse Holo"
   ],
   "43": [
    "Regular",
    "Reverse Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo"
   ],
   "45": [
    "Regular",
    "Reverse Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo"
   ],
   "47": [
    "Regular",
    "Reverse Holo"
   ],
   "48": [
    "Holo",
    "Reverse Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo"
   ],
   "50": [
    "Holo"
   ],
   "51": [
    "Regular",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo"
   ],
   "53": [
    "Regular",
    "Reverse Holo"
   ],
   "54": [
    "Regular",
    "Reverse Holo"
   ],
   "55": [
    "Regular",
    "Reverse Holo"
   ],
   "56": [
    "Holo",
    "Reverse Holo"
   ],
   "57": [
    "Regular",
    "Reverse Holo"
   ],
   "58": [
    "Regular",
    "Reverse Holo"
   ],
   "59": [
    "Regular",
    "Reverse Holo"
   ],
   "60": [
    "Holo"
   ],
   "61": [
    "Regular",
    "Reverse Holo"
   ],
   "62": [
    "Regular",
    "Reverse Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo"
   ],
   "64": [
    "Holo",
    "Reverse Holo"
   ],
   "65": [
    "Regular",
    "Reverse Holo"
   ],
   "66": [
    "Regular",
    "Reverse Holo"
   ],
   "67": [
    "Regular",
    "Reverse Holo"
   ],
   "68": [
    "Regular",
    "Reverse Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo"
   ],
   "70": [
    "Regular",
    "Reverse Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo"
   ],
   "72": [
    "Regular",
    "Reverse Holo"
   ],
   "73": [
    "Holo",
    "Reverse Holo"
   ],
   "74": [
    "Holo",
    "Reverse Holo"
   ],
   "75": [
    "Regular",
    "Reverse Holo"
   ],
   "76": [
    "Regular",
    "Reverse Holo"
   ],
   "77": [
    "Holo"
   ],
   "78": [
    "Regular",
    "Reverse Holo"
   ],
   "79": [
    "Regular",
    "Reverse Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo"
   ],
   "81": [
    "Regular",
    "Reverse Holo"
   ],
   "82": [
    "Regular",
    "Reverse Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo"
   ],
   "84": [
    "Regular",
    "Reverse Holo"
   ],
   "85": [
    "Regular",
    "Reverse Holo"
   ],
   "86": [
    "Holo"
   ],
   "87": [
    "Regular",
    "Reverse Holo"
   ],
   "88": [
    "Holo",
    "Reverse Holo"
   ],
   "89": [
    "Regular",
    "Reverse Holo"
   ],
   "90": [
    "Regular",
    "Reverse Holo"
   ],
   "91": [
    "Regular",
    "Reverse Holo"
   ],
   "92": [
    "Regular",
    "Reverse Holo"
   ],
   "93": [
    "Holo",
    "Reverse Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo",
    "Reverse Holo"
   ],
   "96": [
    "Regular",
    "Reverse Holo"
   ],
   "97": [
    "Regular",
    "Reverse Holo"
   ],
   "98": [
    "Regular",
    "Reverse Holo"
   ],
   "99": [
    "Regular",
    "Reverse Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Regular",
    "Reverse Holo"
   ],
   "102": [
    "Regular",
    "Reverse Holo"
   ],
   "103": [
    "Regular",
    "Reverse Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Regular",
    "Reverse Holo"
   ],
   "106": [
    "Regular",
    "Reverse Holo"
   ],
   "107": [
    "Regular",
    "Reverse Holo"
   ],
   "108": [
    "Regular",
    "Reverse Holo"
   ],
   "109": [
    "Regular",
    "Reverse Holo"
   ],
   "110": [
    "Regular",
    "Reverse Holo"
   ],
   "111": [
    "Regular",
    "Reverse Holo"
   ],
   "112": [
    "Regular",
    "Reverse Holo"
   ],
   "113": [
    "Regular",
    "Reverse Holo"
   ],
   "114": [
    "Regular",
    "Reverse Holo"
   ],
   "115": [
    "Regular",
    "Reverse Holo"
   ],
   "116": [
    "Regular",
    "Reverse Holo"
   ],
   "117": [
    "Regular",
    "Reverse Holo"
   ],
   "118": [
    "Regular",
    "Reverse Holo"
   ],
   "119": [
    "Regular",
    "Reverse Holo"
   ],
   "120": [
    "Regular",
    "Reverse Holo"
   ],
   "121": [
    "Regular",
    "Reverse Holo"
   ],
   "122": [
    "Regular",
    "Reverse Holo"
   ],
   "123": [
    "Regular",
    "Reverse Holo"
   ],
   "124": [
    "Regular",
    "Reverse Holo"
   ],
   "125": [
    "Regular",
    "Reverse Holo"
   ],
   "126": [
    "Regular",
    "Reverse Holo"
   ],
   "127": [
    "Regular",
    "Reverse Holo"
   ],
   "128": [
    "Regular",
    "Reverse Holo"
   ],
   "129": [
    "Regular",
    "Reverse Holo"
   ],
   "130": [
    "Regular",
    "Reverse Holo"
   ],
   "131": [
    "Regular",
    "Reverse Holo"
   ],
   "132": [
    "Regular",
    "Reverse Holo"
   ],
   "133": [
    "Holo"
   ],
   "134": [
    "Holo"
   ],
   "135": [
    "Holo"
   ],
   "136": [
    "Holo"
   ],
   "137": [
    "Holo"
   ],
   "138": [
    "Holo"
   ],
   "139": [
    "Holo"
   ],
   "140": [
    "Holo"
   ],
   "141": [
    "Holo"
   ],
   "142": [
    "Holo"
   ],
   "143": [
    "Holo"
   ],
   "144": [
    "Holo"
   ],
   "145": [
    "Holo"
   ],
   "146": [
    "Holo"
   ],
   "147": [
    "Holo"
   ],
   "148": [
    "Holo"
   ],
   "149": [
    "Holo"
   ],
   "150": [
    "Holo"
   ],
   "151": [
    "Holo"
   ],
   "152": [
    "Holo"
   ],
   "153": [
    "Holo"
   ],
   "154": [
    "Holo"
   ],
   "155": [
    "Holo"
   ],
   "156": [
    "Holo"
   ],
   "157": [
    "Holo"
   ],
   "158": [
    "Holo"
   ],
   "159": [
    "Holo"
   ],
   "160": [
    "Holo"
   ],
   "161": [
    "Holo"
   ],
   "162": [
    "Holo"
   ],
   "163": [
    "Holo"
   ],
   "164": [
    "Holo"
   ],
   "165": [
    "Holo"
   ],
   "166": [
    "Holo"
   ],
   "167": [
    "Holo"
   ],
   "168": [
    "Holo"
   ],
   "169": [
    "Holo"
   ],
   "170": [
    "Holo"
   ],
   "171": [
    "Holo"
   ],
   "172": [
    "Holo"
   ],
   "173": [
    "Holo"
   ],
   "174": [
    "Holo"
   ],
   "175": [
    "Holo"
   ],
   "176": [
    "Holo"
   ],
   "177": [
    "Holo"
   ],
   "178": [
    "Holo"
   ],
   "179": [
    "Holo"
   ],
   "180": [
    "Holo"
   ],
   "181": [
    "Holo"
   ],
   "182": [
    "Holo"
   ],
   "183": [
    "Holo"
   ],
   "184": [
    "Holo"
   ],
   "185": [
    "Holo"
   ],
   "186": [
    "Holo"
   ],
   "187": [
    "Holo"
   ],
   "188": [
    "Holo"
   ]
  },
  "me2": {
   "1": [
    "Regular",
    "Reverse Holo"
   ],
   "2": [
    "Regular",
    "Reverse Holo"
   ],
   "3": [
    "Holo",
    "Reverse Holo"
   ],
   "4": [
    "Holo"
   ],
   "5": [
    "Regular",
    "Reverse Holo"
   ],
   "6": [
    "Regular",
    "Reverse Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo"
   ],
   "8": [
    "Holo",
    "Reverse Holo"
   ],
   "9": [
    "Regular",
    "Reverse Holo"
   ],
   "10": [
    "Regular",
    "Reverse Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo"
   ],
   "12": [
    "Regular",
    "Reverse Holo"
   ],
   "13": [
    "Holo"
   ],
   "14": [
    "Holo",
    "Reverse Holo"
   ],
   "15": [
    "Regular",
    "Reverse Holo"
   ],
   "16": [
    "Regular",
    "Reverse Holo"
   ],
   "17": [
    "Holo",
    "Reverse Holo"
   ],
   "18": [
    "Holo"
   ],
   "19": [
    "Regular",
    "Reverse Holo"
   ],
   "20": [
    "Regular",
    "Reverse Holo"
   ],
   "21": [
    "Regular",
    "Reverse Holo"
   ],
   "22": [
    "Regular",
    "Reverse Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo"
   ],
   "24": [
    "Regular",
    "Reverse Holo"
   ],
   "25": [
    "Regular",
    "Reverse Holo"
   ],
   "26": [
    "Holo",
    "Reverse Holo"
   ],
   "27": [
    "Regular",
    "Reverse Holo"
   ],
   "28": [
    "Regular",
    "Reverse Holo"
   ],
   "29": [
    "Holo"
   ],
   "30": [
    "Regular",
    "Reverse Holo"
   ],
   "31": [
    "Regular",
    "Reverse Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo"
   ],
   "33": [
    "Regular",
    "Reverse Holo"
   ],
   "34": [
    "Holo",
    "Reverse Holo"
   ],
   "35": [
    "Regular",
    "Reverse Holo"
   ],
   "36": [
    "Holo"
   ],
   "37": [
    "Regular",
    "Reverse Holo"
   ],
   "38": [
    "Regular",
    "Reverse Holo"
   ],
   "39": [
    "Regular",
    "Reverse Holo"
   ],
   "40": [
    "Regular",
    "Reverse Holo"
   ],
   "41": [
    "Holo"
   ],
   "42": [
    "Regular",
    "Reverse Holo"
   ],
   "43": [
    "Regular",
    "Reverse Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo"
   ],
   "45": [
    "Reverse Holo",
    "Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo"
   ],
   "47": [
    "Regular",
    "Reverse Holo"
   ],
   "48": [
    "Regular",
    "Reverse Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo"
   ],
   "50": [
    "Regular",
    "Reverse Holo"
   ],
   "51": [
    "Regular",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo"
   ],
   "53": [
    "Holo",
    "Reverse Holo"
   ],
   "54": [
    "Regular",
    "Reverse Holo"
   ],
   "55": [
    "Regular",
    "Reverse Holo"
   ],
   "56": [
    "Holo"
   ],
   "57": [
    "Regular",
    "Reverse Holo"
   ],
   "58": [
    "Regular",
    "Reverse Holo"
   ],
   "59": [
    "Regular",
    "Reverse Holo"
   ],
   "60": [
    "Regular",
    "Reverse Holo"
   ],
   "61": [
    "Holo"
   ],
   "62": [
    "Regular",
    "Reverse Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo"
   ],
   "64": [
    "Regular",
    "Reverse Holo"
   ],
   "65": [
    "Regular",
    "Reverse Holo"
   ],
   "66": [
    "Regular",
    "Reverse Holo"
   ],
   "67": [
    "Regular",
    "Reverse Holo"
   ],
   "68": [
    "Holo",
    "Reverse Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo"
   ],
   "70": [
    "Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo"
   ],
   "72": [
    "Regular",
    "Reverse Holo"
   ],
   "73": [
    "Regular",
    "Reverse Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo"
   ],
   "75": [
    "Regular",
    "Reverse Holo"
   ],
   "76": [
    "Regular",
    "Reverse Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo"
   ],
   "78": [
    "Regular",
    "Reverse Holo"
   ],
   "79": [
    "Holo",
    "Reverse Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo"
   ],
   "81": [
    "Regular",
    "Reverse Holo"
   ],
   "82": [
    "Regular",
    "Reverse Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo"
   ],
   "84": [
    "Holo"
   ],
   "85": [
    "Regular",
    "Reverse Holo"
   ],
   "86": [
    "Regular",
    "Reverse Holo"
   ],
   "87": [
    "Regular",
    "Reverse Holo"
   ],
   "88": [
    "Regular",
    "Reverse Holo"
   ],
   "89": [
    "Regular",
    "Reverse Holo"
   ],
   "90": [
    "Regular",
    "Reverse Holo"
   ],
   "91": [
    "Regular",
    "Reverse Holo"
   ],
   "92": [
    "Regular",
    "Reverse Holo"
   ],
   "93": [
    "Regular",
    "Reverse Holo"
   ],
   "94": [
    "Regular",
    "Reverse Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ],
   "121": [
    "Holo"
   ],
   "122": [
    "Holo"
   ],
   "123": [
    "Holo"
   ],
   "124": [
    "Holo"
   ],
   "125": [
    "Holo"
   ],
   "126": [
    "Holo"
   ],
   "127": [
    "Holo"
   ],
   "128": [
    "Holo"
   ],
   "129": [
    "Holo"
   ]
  },
  "me2pt5": {
   "1": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "2": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "3": [
    "Holo"
   ],
   "4": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "5": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "6": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "8": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "9": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "10": [
    "Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "12": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "13": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "14": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "15": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "16": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "17": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "18": [
    "Regular",
    "Reverse Holo",
    "Team Rocket",
    "Energy Pattern"
   ],
   "19": [
    "Holo",
    "Energy Pattern",
    "Team Rocket",
    "Reverse Holo"
   ],
   "20": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "21": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "22": [
    "Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "24": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "25": [
    "Holo",
    "Quick Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "26": [
    "Holo"
   ],
   "27": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "28": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "29": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "30": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "31": [
    "Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "33": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "34": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "35": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "36": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "37": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "38": [
    "Holo"
   ],
   "39": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "40": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "41": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "42": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "43": [
    "Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "45": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "46": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "47": [
    "Holo"
   ],
   "48": [
    "Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "50": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "51": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "52": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "53": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "54": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "55": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "56": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "57": [
    "Holo"
   ],
   "58": [
    "Holo"
   ],
   "59": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "60": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "61": [
    "Holo"
   ],
   "62": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "63": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "64": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "65": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "66": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "67": [
    "Holo",
    "Quick Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "68": [
    "Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "70": [
    "Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "72": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "73": [
    "Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "75": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "76": [
    "Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "78": [
    "Holo",
    "Energy Pattern",
    "Team Rocket",
    "Reverse Holo"
   ],
   "79": [
    "Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "81": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "82": [
    "Holo",
    "Love Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "84": [
    "Holo"
   ],
   "85": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "86": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "87": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "88": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "91": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "92": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "93": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "94": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "95": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "96": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "97": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "98": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "99": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "100": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "101": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "102": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "103": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "104": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "105": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "106": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "109": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "110": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "118": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "119": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "120": [
    "Holo",
    "Dusk Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "121": [
    "Holo"
   ],
   "122": [
    "Holo",
    "Friend Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "123": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "124": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "125": [
    "Holo"
   ],
   "126": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "127": [
    "Holo",
    "Energy Pattern",
    "Team Rocket",
    "Reverse Holo"
   ],
   "128": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "129": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "130": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "131": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "132": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "133": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "134": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "135": [
    "Holo"
   ],
   "136": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "137": [
    "Holo"
   ],
   "138": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "139": [
    "Holo"
   ],
   "140": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "141": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "142": [
    "Holo"
   ],
   "143": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "144": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "145": [
    "Holo"
   ],
   "146": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "147": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "148": [
    "Holo",
    "Quick Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "149": [
    "Holo"
   ],
   "150": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "151": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "152": [
    "Holo"
   ],
   "153": [
    "Holo",
    "Friend Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "154": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "155": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "156": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "157": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "158": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "159": [
    "Regular",
    "Reverse Holo",
    "Quick Ball",
    "Energy Pattern"
   ],
   "160": [
    "Holo"
   ],
   "161": [
    "Regular",
    "Reverse Holo",
    "Energy Pattern",
    "Team Rocket"
   ],
   "162": [
    "Holo"
   ],
   "163": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "164": [
    "Holo"
   ],
   "165": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "166": [
    "Regular",
    "Reverse Holo",
    "Love Ball",
    "Energy Pattern"
   ],
   "167": [
    "Holo"
   ],
   "168": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "169": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "170": [
    "Holo",
    "Poke Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "171": [
    "Regular",
    "Reverse Holo",
    "Dusk Ball",
    "Energy Pattern"
   ],
   "172": [
    "Holo"
   ],
   "173": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "174": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "175": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "176": [
    "Regular",
    "Reverse Holo",
    "Friend Ball",
    "Energy Pattern"
   ],
   "177": [
    "Regular",
    "Reverse Holo",
    "Poke Ball",
    "Energy Pattern"
   ],
   "178": [
    "Holo",
    "Love Ball",
    "Energy Pattern",
    "Reverse Holo"
   ],
   "179": [
    "Holo"
   ],
   "180": [
    "Regular",
    "Reverse Holo"
   ],
   "181": [
    "Regular",
    "Reverse Holo"
   ],
   "182": [
    "Regular",
    "Reverse Holo"
   ],
   "183": [
    "Regular",
    "Reverse Holo"
   ],
   "184": [
    "Regular",
    "Reverse Holo"
   ],
   "185": [
    "Regular",
    "Reverse Holo"
   ],
   "186": [
    "Regular",
    "Reverse Holo"
   ],
   "187": [
    "Regular",
    "Reverse Holo"
   ],
   "188": [
    "Regular",
    "Reverse Holo"
   ],
   "189": [
    "Regular",
    "Reverse Holo"
   ],
   "190": [
    "Regular",
    "Reverse Holo"
   ],
   "191": [
    "Regular",
    "Reverse Holo"
   ],
   "192": [
    "Regular",
    "Reverse Holo"
   ],
   "193": [
    "Regular",
    "Reverse Holo"
   ],
   "194": [
    "Regular",
    "Reverse Holo"
   ],
   "195": [
    "Regular",
    "Reverse Holo"
   ],
   "196": [
    "Regular",
    "Reverse Holo"
   ],
   "197": [
    "Regular",
    "Reverse Holo"
   ],
   "198": [
    "Regular",
    "Reverse Holo"
   ],
   "199": [
    "Regular",
    "Reverse Holo"
   ],
   "200": [
    "Regular",
    "Reverse Holo"
   ],
   "201": [
    "Regular",
    "Reverse Holo"
   ],
   "202": [
    "Regular",
    "Reverse Holo"
   ],
   "203": [
    "Regular",
    "Reverse Holo"
   ],
   "204": [
    "Regular",
    "Reverse Holo"
   ],
   "205": [
    "Regular",
    "Reverse Holo"
   ],
   "206": [
    "Regular",
    "Reverse Holo"
   ],
   "207": [
    "Regular",
    "Reverse Holo"
   ],
   "208": [
    "Regular",
    "Reverse Holo"
   ],
   "209": [
    "Regular",
    "Reverse Holo"
   ],
   "210": [
    "Regular",
    "Reverse Holo"
   ],
   "211": [
    "Regular",
    "Reverse Holo"
   ],
   "212": [
    "Regular",
    "Reverse Holo"
   ],
   "213": [
    "Regular",
    "Reverse Holo"
   ],
   "214": [
    "Regular",
    "Reverse Holo"
   ],
   "215": [
    "Regular",
    "Reverse Holo"
   ],
   "216": [
    "Regular",
    "Reverse Holo"
   ],
   "217": [
    "Regular",
    "Reverse Holo"
   ],
   "218": [
    "Holo"
   ],
   "219": [
    "Holo"
   ],
   "220": [
    "Holo"
   ],
   "221": [
    "Holo"
   ],
   "222": [
    "Holo"
   ],
   "223": [
    "Holo"
   ],
   "224": [
    "Holo"
   ],
   "225": [
    "Holo"
   ],
   "226": [
    "Holo"
   ],
   "227": [
    "Holo"
   ],
   "228": [
    "Holo"
   ],
   "229": [
    "Holo"
   ],
   "230": [
    "Holo"
   ],
   "231": [
    "Holo"
   ],
   "232": [
    "Holo"
   ],
   "233": [
    "Holo"
   ],
   "234": [
    "Holo"
   ],
   "235": [
    "Holo"
   ],
   "236": [
    "Holo"
   ],
   "237": [
    "Holo"
   ],
   "238": [
    "Holo"
   ],
   "239": [
    "Holo"
   ],
   "240": [
    "Holo"
   ],
   "241": [
    "Holo"
   ],
   "242": [
    "Holo"
   ],
   "243": [
    "Holo"
   ],
   "244": [
    "Holo"
   ],
   "245": [
    "Holo"
   ],
   "246": [
    "Holo"
   ],
   "247": [
    "Holo"
   ],
   "248": [
    "Holo"
   ],
   "249": [
    "Holo"
   ],
   "250": [
    "Holo"
   ],
   "251": [
    "Holo"
   ],
   "252": [
    "Holo"
   ],
   "253": [
    "Holo"
   ],
   "254": [
    "Holo"
   ],
   "255": [
    "Holo"
   ],
   "256": [
    "Holo"
   ],
   "257": [
    "Holo"
   ],
   "258": [
    "Holo"
   ],
   "259": [
    "Holo"
   ],
   "260": [
    "Holo"
   ],
   "261": [
    "Holo"
   ],
   "262": [
    "Holo"
   ],
   "263": [
    "Holo"
   ],
   "264": [
    "Holo"
   ],
   "265": [
    "Holo"
   ],
   "266": [
    "Holo"
   ],
   "267": [
    "Holo"
   ],
   "268": [
    "Holo"
   ],
   "269": [
    "Holo"
   ],
   "270": [
    "Holo"
   ],
   "271": [
    "Holo"
   ],
   "272": [
    "Holo"
   ],
   "273": [
    "Holo"
   ],
   "274": [
    "Holo"
   ],
   "275": [
    "Holo"
   ],
   "276": [
    "Holo"
   ],
   "277": [
    "Holo"
   ],
   "278": [
    "Holo"
   ],
   "279": [
    "Holo"
   ],
   "280": [
    "Holo"
   ],
   "281": [
    "Holo"
   ],
   "282": [
    "Holo"
   ],
   "283": [
    "Holo"
   ],
   "284": [
    "Holo"
   ],
   "285": [
    "Holo"
   ],
   "286": [
    "Holo"
   ],
   "287": [
    "Holo"
   ],
   "288": [
    "Holo"
   ],
   "289": [
    "Holo"
   ],
   "290": [
    "Holo"
   ],
   "291": [
    "Holo"
   ],
   "292": [
    "Holo"
   ],
   "293": [
    "Holo"
   ],
   "294": [
    "Holo"
   ],
   "295": [
    "Holo"
   ]
  },
  "me3": {
   "1": [
    "Regular",
    "Reverse Holo"
   ],
   "2": [
    "Regular",
    "Reverse Holo"
   ],
   "3": [
    "Regular",
    "Reverse Holo"
   ],
   "4": [
    "Regular",
    "Reverse Holo"
   ],
   "5": [
    "Regular",
    "Reverse Holo"
   ],
   "6": [
    "Holo",
    "Reverse Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo"
   ],
   "8": [
    "Regular",
    "Reverse Holo"
   ],
   "9": [
    "Regular",
    "Reverse Holo"
   ],
   "10": [
    "Regular",
    "Reverse Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo"
   ],
   "12": [
    "Holo"
   ],
   "13": [
    "Regular",
    "Reverse Holo"
   ],
   "14": [
    "Regular",
    "Reverse Holo"
   ],
   "15": [
    "Regular",
    "Reverse Holo"
   ],
   "16": [
    "Holo"
   ],
   "17": [
    "Regular",
    "Reverse Holo"
   ],
   "18": [
    "Regular",
    "Reverse Holo"
   ],
   "19": [
    "Holo",
    "Reverse Holo"
   ],
   "20": [
    "Regular",
    "Reverse Holo"
   ],
   "21": [
    "Holo"
   ],
   "22": [
    "Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo"
   ],
   "24": [
    "Holo",
    "Reverse Holo"
   ],
   "25": [
    "Regular",
    "Reverse Holo"
   ],
   "26": [
    "Regular",
    "Reverse Holo"
   ],
   "27": [
    "Regular",
    "Reverse Holo"
   ],
   "28": [
    "Holo",
    "Reverse Holo"
   ],
   "29": [
    "Regular",
    "Reverse Holo"
   ],
   "30": [
    "Regular",
    "Reverse Holo"
   ],
   "31": [
    "Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo"
   ],
   "33": [
    "Regular",
    "Reverse Holo"
   ],
   "34": [
    "Regular",
    "Reverse Holo"
   ],
   "35": [
    "Regular",
    "Reverse Holo"
   ],
   "36": [
    "Regular",
    "Reverse Holo"
   ],
   "37": [
    "Regular",
    "Reverse Holo"
   ],
   "38": [
    "Regular",
    "Reverse Holo"
   ],
   "39": [
    "Regular",
    "Reverse Holo"
   ],
   "40": [
    "Regular",
    "Reverse Holo"
   ],
   "41": [
    "Holo",
    "Reverse Holo"
   ],
   "42": [
    "Regular",
    "Reverse Holo"
   ],
   "43": [
    "Regular",
    "Reverse Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo"
   ],
   "45": [
    "Holo",
    "Reverse Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo"
   ],
   "47": [
    "Holo"
   ],
   "48": [
    "Regular",
    "Reverse Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo"
   ],
   "50": [
    "Holo",
    "Reverse Holo"
   ],
   "51": [
    "Regular",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo"
   ],
   "53": [
    "Holo"
   ],
   "54": [
    "Holo",
    "Reverse Holo"
   ],
   "55": [
    "Holo"
   ],
   "56": [
    "Regular",
    "Reverse Holo"
   ],
   "57": [
    "Regular",
    "Reverse Holo"
   ],
   "58": [
    "Regular",
    "Reverse Holo"
   ],
   "59": [
    "Regular",
    "Reverse Holo"
   ],
   "60": [
    "Regular",
    "Reverse Holo"
   ],
   "61": [
    "Regular",
    "Reverse Holo"
   ],
   "62": [
    "Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo"
   ],
   "64": [
    "Regular",
    "Reverse Holo"
   ],
   "65": [
    "Regular",
    "Reverse Holo"
   ],
   "66": [
    "Regular",
    "Reverse Holo"
   ],
   "67": [
    "Regular",
    "Reverse Holo"
   ],
   "68": [
    "Regular",
    "Reverse Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo"
   ],
   "70": [
    "Regular",
    "Reverse Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo"
   ],
   "72": [
    "Regular",
    "Reverse Holo"
   ],
   "73": [
    "Regular",
    "Reverse Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo"
   ],
   "75": [
    "Regular",
    "Reverse Holo"
   ],
   "76": [
    "Regular",
    "Reverse Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo"
   ],
   "78": [
    "Regular",
    "Reverse Holo"
   ],
   "79": [
    "Regular",
    "Reverse Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo"
   ],
   "81": [
    "Regular",
    "Reverse Holo"
   ],
   "82": [
    "Regular",
    "Reverse Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo"
   ],
   "84": [
    "Regular",
    "Reverse Holo"
   ],
   "85": [
    "Regular",
    "Reverse Holo"
   ],
   "86": [
    "Holo",
    "Reverse Holo"
   ],
   "87": [
    "Holo",
    "Reverse Holo"
   ],
   "88": [
    "Holo",
    "Reverse Holo"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Holo"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ],
   "121": [
    "Holo"
   ],
   "122": [
    "Holo"
   ],
   "123": [
    "Holo"
   ],
   "124": [
    "Holo"
   ]
  },
  "me4": {
   "1": [
    "Regular",
    "Reverse Holo"
   ],
   "2": [
    "Regular",
    "Reverse Holo"
   ],
   "3": [
    "Holo"
   ],
   "4": [
    "Regular",
    "Reverse Holo"
   ],
   "5": [
    "Regular",
    "Reverse Holo"
   ],
   "6": [
    "Regular",
    "Reverse Holo"
   ],
   "7": [
    "Holo",
    "Reverse Holo"
   ],
   "8": [
    "Regular",
    "Reverse Holo"
   ],
   "9": [
    "Regular",
    "Reverse Holo"
   ],
   "10": [
    "Holo",
    "Reverse Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo"
   ],
   "12": [
    "Regular",
    "Reverse Holo"
   ],
   "13": [
    "Holo",
    "Reverse Holo"
   ],
   "14": [
    "Regular",
    "Reverse Holo"
   ],
   "15": [
    "Holo"
   ],
   "16": [
    "Regular",
    "Reverse Holo"
   ],
   "17": [
    "Regular",
    "Reverse Holo"
   ],
   "18": [
    "Regular",
    "Reverse Holo"
   ],
   "19": [
    "Holo",
    "Reverse Holo"
   ],
   "20": [
    "Regular",
    "Reverse Holo"
   ],
   "21": [
    "Regular",
    "Reverse Holo"
   ],
   "22": [
    "Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo"
   ],
   "24": [
    "Regular",
    "Reverse Holo"
   ],
   "25": [
    "Regular",
    "Reverse Holo"
   ],
   "26": [
    "Regular",
    "Reverse Holo"
   ],
   "27": [
    "Regular",
    "Reverse Holo"
   ],
   "28": [
    "Regular",
    "Reverse Holo"
   ],
   "29": [
    "Holo",
    "Reverse Holo"
   ],
   "30": [
    "Regular",
    "Reverse Holo"
   ],
   "31": [
    "Regular",
    "Reverse Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo"
   ],
   "33": [
    "Regular",
    "Reverse Holo"
   ],
   "34": [
    "Regular",
    "Reverse Holo"
   ],
   "35": [
    "Holo"
   ],
   "36": [
    "Regular",
    "Reverse Holo"
   ],
   "37": [
    "Regular",
    "Reverse Holo"
   ],
   "38": [
    "Regular",
    "Reverse Holo"
   ],
   "39": [
    "Holo",
    "Reverse Holo"
   ],
   "40": [
    "Regular",
    "Reverse Holo"
   ],
   "41": [
    "Holo"
   ],
   "42": [
    "Holo",
    "Reverse Holo"
   ],
   "43": [
    "Regular",
    "Reverse Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo"
   ],
   "45": [
    "Regular",
    "Reverse Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo"
   ],
   "47": [
    "Regular",
    "Reverse Holo"
   ],
   "48": [
    "Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo"
   ],
   "50": [
    "Regular",
    "Reverse Holo"
   ],
   "51": [
    "Holo",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo"
   ],
   "53": [
    "Regular",
    "Reverse Holo"
   ],
   "54": [
    "Regular",
    "Reverse Holo"
   ],
   "55": [
    "Holo"
   ],
   "56": [
    "Regular",
    "Reverse Holo"
   ],
   "57": [
    "Regular",
    "Reverse Holo"
   ],
   "58": [
    "Regular",
    "Reverse Holo"
   ],
   "59": [
    "Regular",
    "Reverse Holo"
   ],
   "60": [
    "Regular",
    "Reverse Holo"
   ],
   "61": [
    "Regular",
    "Reverse Holo"
   ],
   "62": [
    "Regular",
    "Reverse Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo"
   ],
   "64": [
    "Holo"
   ],
   "65": [
    "Holo"
   ],
   "66": [
    "Regular",
    "Reverse Holo"
   ],
   "67": [
    "Regular",
    "Reverse Holo"
   ],
   "68": [
    "Holo",
    "Reverse Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo"
   ],
   "70": [
    "Regular",
    "Reverse Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo"
   ],
   "72": [
    "Regular",
    "Reverse Holo"
   ],
   "73": [
    "Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo"
   ],
   "75": [
    "Regular",
    "Reverse Holo"
   ],
   "76": [
    "Regular",
    "Reverse Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo"
   ],
   "78": [
    "Regular",
    "Reverse Holo"
   ],
   "79": [
    "Regular",
    "Reverse Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo"
   ],
   "81": [
    "Regular",
    "Reverse Holo"
   ],
   "82": [
    "Regular",
    "Reverse Holo"
   ],
   "83": [
    "Regular",
    "Reverse Holo"
   ],
   "84": [
    "Holo",
    "Reverse Holo"
   ],
   "85": [
    "Holo",
    "Reverse Holo"
   ],
   "86": [
    "Holo",
    "Reverse Holo"
   ],
   "87": [
    "Holo"
   ],
   "88": [
    "Holo"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Holo"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ],
   "121": [
    "Holo"
   ]
  },
  "me5": {
   "1": [
    "Regular",
    "Reverse Holo"
   ],
   "2": [
    "Regular",
    "Reverse Holo"
   ],
   "3": [
    "Regular",
    "Reverse Holo"
   ],
   "4": [
    "Holo"
   ],
   "5": [
    "Regular",
    "Reverse Holo"
   ],
   "6": [
    "Regular",
    "Reverse Holo"
   ],
   "7": [
    "Regular",
    "Reverse Holo"
   ],
   "8": [
    "Holo"
   ],
   "9": [
    "Regular",
    "Reverse Holo"
   ],
   "10": [
    "Regular",
    "Reverse Holo"
   ],
   "11": [
    "Regular",
    "Reverse Holo"
   ],
   "12": [
    "Holo",
    "Reverse Holo"
   ],
   "13": [
    "Regular",
    "Reverse Holo"
   ],
   "14": [
    "Regular",
    "Reverse Holo"
   ],
   "15": [
    "Regular",
    "Reverse Holo"
   ],
   "16": [
    "Holo"
   ],
   "17": [
    "Regular",
    "Reverse Holo"
   ],
   "18": [
    "Regular",
    "Reverse Holo"
   ],
   "19": [
    "Regular",
    "Reverse Holo"
   ],
   "20": [
    "Holo",
    "Reverse Holo"
   ],
   "21": [
    "Regular",
    "Reverse Holo"
   ],
   "22": [
    "Regular",
    "Reverse Holo"
   ],
   "23": [
    "Regular",
    "Reverse Holo"
   ],
   "24": [
    "Regular",
    "Reverse Holo"
   ],
   "25": [
    "Regular",
    "Reverse Holo"
   ],
   "26": [
    "Regular",
    "Reverse Holo"
   ],
   "27": [
    "Holo"
   ],
   "28": [
    "Holo",
    "Reverse Holo"
   ],
   "29": [
    "Regular",
    "Reverse Holo"
   ],
   "30": [
    "Regular",
    "Reverse Holo"
   ],
   "31": [
    "Holo"
   ],
   "32": [
    "Regular",
    "Reverse Holo"
   ],
   "33": [
    "Regular",
    "Reverse Holo"
   ],
   "34": [
    "Regular",
    "Reverse Holo"
   ],
   "35": [
    "Holo",
    "Reverse Holo"
   ],
   "36": [
    "Regular",
    "Reverse Holo"
   ],
   "37": [
    "Regular",
    "Reverse Holo"
   ],
   "38": [
    "Holo"
   ],
   "39": [
    "Regular",
    "Reverse Holo"
   ],
   "40": [
    "Regular",
    "Reverse Holo"
   ],
   "41": [
    "Regular",
    "Reverse Holo"
   ],
   "42": [
    "Regular",
    "Reverse Holo"
   ],
   "43": [
    "Regular",
    "Reverse Holo"
   ],
   "44": [
    "Regular",
    "Reverse Holo"
   ],
   "45": [
    "Holo"
   ],
   "46": [
    "Regular",
    "Reverse Holo"
   ],
   "47": [
    "Holo",
    "Reverse Holo"
   ],
   "48": [
    "Holo"
   ],
   "49": [
    "Regular",
    "Reverse Holo"
   ],
   "50": [
    "Regular",
    "Reverse Holo"
   ],
   "51": [
    "Regular",
    "Reverse Holo"
   ],
   "52": [
    "Regular",
    "Reverse Holo"
   ],
   "53": [
    "Regular",
    "Reverse Holo"
   ],
   "54": [
    "Regular",
    "Reverse Holo"
   ],
   "55": [
    "Holo"
   ],
   "56": [
    "Holo",
    "Reverse Holo"
   ],
   "57": [
    "Regular",
    "Reverse Holo"
   ],
   "58": [
    "Regular",
    "Reverse Holo"
   ],
   "59": [
    "Holo",
    "Reverse Holo"
   ],
   "60": [
    "Regular",
    "Reverse Holo"
   ],
   "61": [
    "Regular",
    "Reverse Holo"
   ],
   "62": [
    "Holo",
    "Reverse Holo"
   ],
   "63": [
    "Regular",
    "Reverse Holo"
   ],
   "64": [
    "Regular",
    "Reverse Holo"
   ],
   "65": [
    "Holo"
   ],
   "66": [
    "Regular",
    "Reverse Holo"
   ],
   "67": [
    "Regular",
    "Reverse Holo"
   ],
   "68": [
    "Regular",
    "Reverse Holo"
   ],
   "69": [
    "Regular",
    "Reverse Holo"
   ],
   "70": [
    "Holo",
    "Reverse Holo"
   ],
   "71": [
    "Regular",
    "Reverse Holo"
   ],
   "72": [
    "Regular",
    "Reverse Holo"
   ],
   "73": [
    "Regular",
    "Reverse Holo"
   ],
   "74": [
    "Regular",
    "Reverse Holo"
   ],
   "75": [
    "Regular",
    "Reverse Holo"
   ],
   "76": [
    "Regular",
    "Reverse Holo"
   ],
   "77": [
    "Regular",
    "Reverse Holo"
   ],
   "78": [
    "Regular",
    "Reverse Holo"
   ],
   "79": [
    "Regular",
    "Reverse Holo"
   ],
   "80": [
    "Regular",
    "Reverse Holo"
   ],
   "81": [
    "Regular",
    "Reverse Holo"
   ],
   "82": [
    "Regular",
    "Reverse Holo"
   ],
   "83": [
    "Holo",
    "Reverse Holo"
   ],
   "84": [
    "Holo",
    "Reverse Holo"
   ],
   "85": [
    "Holo"
   ],
   "86": [
    "Holo"
   ],
   "87": [
    "Holo"
   ],
   "88": [
    "Holo"
   ],
   "89": [
    "Holo"
   ],
   "90": [
    "Holo"
   ],
   "91": [
    "Holo"
   ],
   "92": [
    "Holo"
   ],
   "93": [
    "Holo"
   ],
   "94": [
    "Holo"
   ],
   "95": [
    "Holo"
   ],
   "96": [
    "Holo"
   ],
   "97": [
    "Holo"
   ],
   "98": [
    "Holo"
   ],
   "99": [
    "Holo"
   ],
   "100": [
    "Holo"
   ],
   "101": [
    "Holo"
   ],
   "102": [
    "Holo"
   ],
   "103": [
    "Holo"
   ],
   "104": [
    "Holo"
   ],
   "105": [
    "Holo"
   ],
   "106": [
    "Holo"
   ],
   "107": [
    "Holo"
   ],
   "108": [
    "Holo"
   ],
   "109": [
    "Holo"
   ],
   "110": [
    "Holo"
   ],
   "111": [
    "Holo"
   ],
   "112": [
    "Holo"
   ],
   "113": [
    "Holo"
   ],
   "114": [
    "Holo"
   ],
   "115": [
    "Holo"
   ],
   "116": [
    "Holo"
   ],
   "117": [
    "Holo"
   ],
   "118": [
    "Holo"
   ],
   "119": [
    "Holo"
   ],
   "120": [
    "Holo"
   ]
  },
  "mep": {
   "1": [
    "Holo"
   ],
   "2": [
    "Holo"
   ],
   "3": [
    "Holo"
   ],
   "4": [
    "Holo"
   ],
   "5": [
    "Holo"
   ],
   "6": [
    "Holo"
   ],
   "7": [
    "Holo"
   ],
   "8": [
    "Holo"
   ],
   "9": [
    "Holo"
   ],
   "10": [
    "Holo"
   ],
   "11": [
    "Holo"
   ],
   "12": [
    "Holo"
   ],
   "13": [
    "Holo"
   ],
   "14": [
    "Holo"
   ],
   "15": [
    "Holo"
   ],
   "16": [
    "Holo"
   ],
   "17": [
    "Holo"
   ],
   "18": [
    "Holo"
   ],
   "19": [
    "Holo"
   ],
   "20": [
    "Holo"
   ],
   "21": [
    "Holo"
   ],
   "22": [
    "Holo"
   ],
   "23": [
    "Holo"
   ],
   "24": [
    "Holo"
   ],
   "25": [
    "Holo"
   ],
   "26": [
    "Holo"
   ],
   "27": [
    "Holo"
   ],
   "28": [
    "Holo"
   ],
   "29": [
    "Holo"
   ],
   "30": [
    "Holo"
   ],
   "31": [
    "Holo"
   ],
   "32": [
    "Holo"
   ],
   "33": [
    "Holo"
   ],
   "34": [
    "Holo"
   ],
   "35": [
    "Holo"
   ],
   "36": [
    "Holo"
   ],
   "37": [
    "Holo"
   ],
   "38": [
    "Holo"
   ],
   "39": [
    "Holo"
   ],
   "40": [
    "Holo"
   ],
   "41": [
    "Holo"
   ],
   "42": [
    "Holo"
   ],
   "43": [
    "Holo"
   ],
   "44": [
    "Holo"
   ],
   "45": [
    "Holo"
   ],
   "64": [
    "Holo"
   ],
   "65": [
    "Holo"
   ],
   "66": [
    "Holo"
   ],
   "67": [
    "Holo"
   ],
   "68": [
    "Holo"
   ],
   "69": [
    "Holo"
   ],
   "70": [
    "Holo"
   ],
   "71": [
    "Holo"
   ],
   "74": [
    "Holo"
   ],
   "75": [
    "Holo"
   ],
   "76": [
    "Holo"
   ],
   "77": [
    "Holo"
   ],
   "78": [
    "Holo"
   ],
   "79": [
    "Holo"
   ],
   "80": [
    "Holo"
   ]
  }
 }
};
